<div class="loadingSpinner">
    <div class="contenidoSpinner">
        <mat-spinner></mat-spinner>
    </div>